import { render, staticRenderFns } from "./customList.vue?vue&type=template&id=ca87b92e&scoped=true&"
import script from "./customList.vue?vue&type=script&lang=js&"
export * from "./customList.vue?vue&type=script&lang=js&"
import style0 from "./customList.vue?vue&type=style&index=0&id=ca87b92e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca87b92e",
  null
  
)

export default component.exports